module.exports = __webpack_public_path__ + "img/confirm-modal.5d664ceb.png";